import Button from "../shared/Button";
import DropdownButton from "../shared/DropdownButton";
import Loading from "../layout/Loading";
import { useUser } from "../../hooks/useQueries";
import { Tag } from "lucide-react";

export default function ProjectHeader({
    saveProject,
    saveAsDraft,
    getProjects,
    onNewProject,
    onPrintSummary,
    onPrint,
    isLoading,
    openDiscountModal,
    openCustomItemModal,
    onPrintClick,
    onRefreshPrice,
    onViewDrafts,
    onOpenDraftFile,
    onOpenOfferModal,
    offerSummary,
    onEngineerNotes,
    notesCount
}) {
    const { user } = useUser();

    const printOptions = () => {
        let options = [];
        options.push({ text: "Summary", value: "Summary" });
        options.push({ text: "Technical", value: "Technical" });
        options.push({ text: "Drawings", value: "Drawing" });
        if (user.userGroupId == 2 || (user.showSalePrice ?? false))
            options.push({ text: "Price Breakdown", value: "SellingPriceBreakdown" });
        if (user.userGroupId == 2 || (user.showCostPrice ?? false))
            options.push({
                text: "Cost Price Breakdown",
                value: "CostPriceBreakdown",
            });
        return options;
    };

    return (
        <div className="border-b border-gray-200 p-3 flex flex-wrap items-center justify-end gap-3">
            <Loading
                cssClass="justify-end mr-auto w-5"
                isCalculating={isLoading}
            />

            <Button
                buttonSize="xs"
                buttoncolor={"primary"}
                cssclass="!rounded-md"
                onClick={getProjects}
            >
                Projects
            </Button>
            <Button
                buttonSize="xs"
                buttoncolor={"primary"}
                cssclass="!rounded-md"
                onClick={onNewProject}
            >
                New Project
            </Button>

            <Button
                buttonSize="xs"
                buttoncolor={"primary"}
                cssclass="!rounded-md"
                onClick={onPrintClick}
            >
                Print
            </Button>

            {(user.userGroupId == 2 || (user.showSalePrice ?? false)) && (
                <Button
                    buttonSize="xs"
                    buttoncolor={"primary"}
                    cssclass="!rounded-md"
                    onClick={openDiscountModal}
                >
                    Discounts
                </Button>
            )}

            <Button
                buttonSize="xs"
                buttoncolor={"primary"}
                cssclass="!rounded-md"
                onClick={openCustomItemModal}
            >
                Custom Item
            </Button>
            <Button
                buttonSize="xs"
                buttoncolor={"primary"}
                cssclass="!rounded-md"
                onClick={onEngineerNotes}
            >
                Engineer Notes{notesCount > 0 ? ` (${notesCount})` : ""}
            </Button>
            <Button
                buttonSize="xs"
                buttoncolor={"primary"}
                cssclass="!rounded-md"
                onClick={onRefreshPrice}
            >
                Refresh Price
            </Button>

            {/*<Button*/}
            {/*    type="button"*/}
            {/*    buttonSize="xs"*/}
            {/*    buttoncolor={"primary"}*/}
            {/*    cssclass="!rounded-md"*/}
            {/*    onClick={(e) => {*/}
            {/*        e.preventDefault();*/}
            {/*        e.stopPropagation();*/}
            {/*        onViewDrafts();*/}
            {/*    }}*/}
            {/*>*/}
            {/*    View Drafts*/}
            {/*</Button>*/}

            {/* ── Open a .mpf draft file from disk and load it into the form ── */}
            <Button
                type="button"
                buttonSize="xs"
                buttoncolor={"primary"}
                cssclass="!rounded-md"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onOpenDraftFile();
                }}
            >
                Open Draft
            </Button>

            <Button
                buttonSize="xs"
                buttoncolor={"primary"}
                cssclass="!rounded-md"
                title="Saves locally and downloads a .mpf file"
                onClick={saveAsDraft}
            >
                Save as Draft
            </Button>

            <Button
                buttonSize="xs"
                buttoncolor={offerSummary ? "success" : "primary"}
                cssclass={`!rounded-md ${offerSummary ? '!bg-green-600 hover:!bg-green-700 !border-green-600' : ''}`}
                onClick={onOpenOfferModal}
            >
                <span className="inline-flex items-center">
                    {/* <Tag className="w-4 h-4 mr-1.5" /> */}
                    Offer Options
                    {offerSummary && (
                        <span className="ml-1.5 w-2 h-2 bg-white rounded-full animate-pulse inline-block"></span>
                    )}
                </span>
            </Button>

            {/* Save Dropdown Button */}
            <DropdownButton
                buttonSize="xs"
                buttoncolor={"primary"}
                cssclass="!rounded-md"
                onClick={(val) => saveProject(val)}
                options={[
                    { text: "Save without revision", value: "Save" },
                    { text: "Save with revision", value: "SaveIncrement" },
                ]}
            >
                Save
            </DropdownButton>

            {offerSummary && (
                <div className="w-full mt-2">
                    <div className="px-3 py-1.5 bg-blue-50 border border-blue-200 rounded-md flex items-center">
                        <span className="text-xs text-gray-600">
                            <span className="font-medium text-blue-700">Offers:</span> {offerSummary}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
}